<template>
    <div class="Background">
        <v-container fluid>
        <v-row no-gutters class="uniform-gap-32">
            <!-- 좌측 컬럼: 플레이어 + 소셜미디어 -->
            <v-col
                cols="12" md="7" xl="8" class="grid-col"
            >
            <!-- 플레이어 카드 -->
            <div class="video-container mb-4">
                <iframe
                    scrolling="no"
                    ref="iframe"
                    :src="EMBEDIEDURL"
                    frameborder="0"
                    allowfullscreen
                    @load="temp"
                    @playing="resizeVideo"
                ></iframe>
            </div>

            <!-- 플레이어 아래 새로고침/안내 -->
            <v-alert class="info_alert" type="info" dense text>
                <span>{{ $store.getters.t('새로고침 버튼을 눌러주셔야 라이브 방송이 스트림온에 반영됩니다.') }}</span>
                <template v-slot:append>
                    <v-btn small icon color="blue darken-2" @click="refreshIframe">
                    <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                </template>
            </v-alert>

            <!--소셜미디어 스트리밍 UI-->
            <SocialLiveStreamingCard
                :standardVal="standardVal"
                :context="liveRelayContext"
                :liveInfo="socialLiveInfo"
                source-type="webrtc"
            />

            </v-col>

            <!-- 우측 컬럼: 스트리밍 상세 정보 + URL INFO -->
            <v-col
            cols="12" md="5" xl="4" class="grid-col"
            >
            <!-- 스트리밍 상세 정보 -->
            <v-card class="rounded-lg elevation-0 mb-6">
                <v-card-title class="py-4 d-flex justify-space-between py-4">
                    <h3 class="tabletitle pb-0">{{ $store.getters.t('스트리밍 상세 정보') }}</h3>
                    <div>
                        <TextButton :buttonText="$store.getters.t('목록')" @click="goLiveList()" class="mr-2"/>
                        <TextButton :buttonText="$store.getters.t('저장')" isPrimary @click="saveChanges" :loading="saveLoading"/>    
                    </div>
                    </v-card-title>
                <v-divider />

                <v-card-text class="pt-4">
                <v-simple-table>
                    <template v-slot:default>
                    <thead>
                        <tr>
                        <th class="thead_custom_left thead_custom_top pa-3" style="height: 60px;">
                            {{ $store.getters.t('Live 스트리밍') }}
                        </th>
                        <th class="thead_custom_right thead_custom_top pa-3">
                            <span>
                            <Input placeholder="name" :value="displayStreamName" viewType="name" :disabled="true" />
                            </span>
                        </th>
                        </tr>
                        <tr>
                        <th class="thead_custom_left pa-3" style="height: 66px;">
                            {{ $store.getters.t('레코딩') }}
                        </th>
                        <th class="thead_custom_right pa-3" style="display:flex;align-items:center;">
                            <CustomSwitch :switchState="switchStates.recording" :toggleSwitch="() => toggleSwitch('recording')" />
                            <span v-if="isRecording === 'stopped'" class="reco_status recording_off">
                            <v-icon x-small class="mdi mdi-square mr-1" color="#999" />
                            {{ $store.getters.t('녹화 중이 아닙니다') }}
                            </span>
                            <span v-if="isRecording === 'recording'" class="reco_status recording_on">
                            <v-icon x-small class="mdi mdi-circle mr-1 blinking" color="#d33333" />
                            {{ $store.getters.t('녹화 중입니다') }}
                            </span>
                            <span v-if="isRecording === 'ready'" class="reco_status recording_waiting">
                            <v-icon small class="mdi mdi-clock-outline mr-1" color="#d33333" />
                            {{ $store.getters.t('영상을 준비하는 중입니다') }}
                            </span>
                        </th>
                        </tr>
                    </thead>
                    </template>
                </v-simple-table>
                </v-card-text>
            </v-card>

            <!--보안옵션-->
            <v-card class="rounded-lg elevation-0 mb-6" v-if="appType == 'secure'">
                <v-card-title class="py-4 d-flex justify-space-between py-4">
                    <h3 class="tabletitle pb-0">{{ $store.getters.t('보안 옵션') }}</h3>
                    <div class="text-right">
                        <TextButton :buttonText="$store.getters.t('플레이어 다운로드')" iconColor="#555" icon="mdi mdi-download" class="ml-2" @click="downloadCode"/>
                        <TextButton :buttonText="$store.getters.t('코드 보기')" iconColor="#555" icon="mdi mdi-xml" class="ml-2" @click="openCode"/>
                    </div>
                </v-card-title>
                <v-divider />

                <v-card-text class="pt-4">
                <v-simple-table>
                    <template v-slot:default>
                    <thead>
                        <tr>
                        <th class="thead_custom_left thead_custom_top pa-3" style="height: 60px;">
                            {{ $store.getters.t('Domain') }}
                        </th>
                        <th class="thead_custom_right thead_custom_top pa-3">
                            <span>
                                <input v-model="domain" class="mt-2 search-input"/>
                            </span>
                        </th>
                        </tr>
                        <tr>
                        <th class="thead_custom_left pa-3" style="height: 66px;">
                            {{ $store.getters.t('Private Key') }}
                        </th>
                        <th class="thead_custom_right pa-3">
                            <span>
                                <input v-model="privateKey" class="mt-2 search-input"/>
                            </span>
                        </th>
                        </tr>
                    </thead>
                    </template>
                </v-simple-table>
                </v-card-text>
            </v-card>

            <!-- URL INFO -->
            <v-card class="rounded-lg elevation-0">
            <v-card-title class="py-4 d-flex justify-space-between align-center">
                <h3 class="tabletitle pb-0">{{ $store.getters.t('INFO') }}</h3>
                <TextButton
                :buttonText="$store.getters.t('다운로드')"
                iconColor="#555"
                icon="mdi-download"
                class="ml-2"
                @click="downloadForm"
                />
            </v-card-title>
            <v-divider />

            <v-card-text class="pt-4">

            <!-- URL 항목들 -->
            <div class="url-info-list">

            <!-- OnPublish Server -->
            <div class="url-block">
                <div class="url-label">{{ $store.getters.t('OnpublishServer') }}</div>
                <div class="url-line">
                <div class="url-text mono-ellipsis" :title="OnpublishServer">{{ OnpublishServer }}</div>
                <v-btn icon color="#999" @click="copyToClipboard(OnpublishServer)">
                    <v-icon small>mdi-content-copy</v-icon>
                </v-btn>
                </div>
            </div>

            <!-- Whip URL -->
            <div class="url-block">
                <div class="url-label">{{ $store.getters.t('Whip URL') }}</div>
                <div class="url-line">
                <div class="url-text mono-ellipsis" :title="whipUrl">{{ whipUrl }}</div>
                <v-btn icon color="#999" @click="copyToClipboard(whipUrl)">
                    <v-icon small>mdi-content-copy</v-icon>
                </v-btn>
                </div>
            </div>

            <!-- Stream Key -->
            <div class="url-block">
                <div class="url-label">{{ $store.getters.t('StreamKey') }}</div>
                <div class="url-line">
                <div class="url-text mono-ellipsis" :title="stream_name">{{ stream_name }}</div>
                <v-btn icon color="#999" @click="copyToClipboard(stream_name)">
                    <v-icon small>mdi-content-copy</v-icon>
                </v-btn>
                </div>
            </div>

            <!-- Embedded URL -->
            <div class="url-block">
                <div class="url-label">{{ $store.getters.t('EMBEDDED URL') }}</div>
                <div class="url-line">
                <div class="url-text mono-ellipsis" :title="EMBEDIEDURL">{{ EMBEDIEDURL }}</div>
                <v-btn icon color="#999" @click="copyToClipboard(EMBEDIEDURL)">
                    <v-icon small>mdi-content-copy</v-icon>
                </v-btn>
                </div>
            </div>

            </div>
        </v-card-text>
            </v-card>
            </v-col>
        </v-row>
        </v-container>

        <!-- 스낵바 -->
        <AppSnackbar :message="snackbarText" :visible="snackbar" :error="snackbarError" />
    
        <AppDialogLarge width="950px" v-model="modalOpen" :persistent="true">
        <template v-slot:title>
            <span class="social_title">{{ $store.getters.t('Player Sample Code') }}</span>
        </template>
        <template v-slot:close>
            <v-btn icon @click="modalOpen = false">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </template>
        <template v-slot:content>
            <div class="code-box">
                <pre><code style="background-color: none !important; ">{{ previewHtml }}</code></pre>
            </div>
            <TextButtonBlock :buttonText="$store.getters.t('닫기')" :width="'49.5%'" @click="modalOpen = false"/>
            <TextButtonBlock :buttonText="$store.getters.t('복사하기')"  @click="copyToClipboardHTML(previewHtml)" :width="'49.2%'" class="ml-2" />
        </template>
    </AppDialogLarge>

    </div>
</template>

<script>
import Input from '@/components/ui/form/FormInput.vue';
// import TextButton from '@/components/ui/button/TextButton2.vue';
import TextButton from '@/components/ui/button/TextButton.vue';
import TextButtonBlock from '@/components/ui/button/TextButtonBlock.vue';
import CustomSwitch from '@/components/ui/switch/CustomSwitch.vue';
import IconButton from '@/components/ui/button/IconButton.vue';
import { mapActions, mapState } from 'vuex';
import WebRtcStreamApi from '@/api/webrtc/WebRtcStreamApi';
import { ssrCompileToFunctions } from 'vue-template-compiler';
import AppSnackbar from "@/components/ui/snackbar/Snackbar.vue";
import JSZip from 'jszip';
import AppDialog from '@/components/app/AppDialog.vue';
import AppDialogLarge from '@/components/app/AppDialogLarge.vue';
import SocialLiveStreamingCard from '@/components/socialupload/SocialLiveStreamingCard.vue';
import { getDisplayStreamName } from '@/utils/streamName';

export default {
    components: {
        Input,
        TextButton,
        TextButtonBlock,
        CustomSwitch,
        IconButton,
        AppSnackbar,
        AppDialog,
        AppDialogLarge,
        SocialLiveStreamingCard
    },
    data() {
        return {
            // stream_name: '',
            // application: '',
            live_status: '',
            info: [],
            saveLoading: false,
            snackbar: false,
            snackbarText: '',
            snackbarError: false,
            privateKey: null,
            // validTime: null,
            modalOpen: false,
            domain: null,
            previewHtml: '',
            appType: '',
        }
    },
    computed: {
        ...mapState('livestatus', {
            switchStates: state => state.switchStates
        }),
        // privateKey(){
        //     if(this.info){
        //         return this.info.private_key;
        //     } else {    
        //         return null;
        //     }
        // },
        // validTime(){
        //     if(this.info){
        //         return this.info.valid_time;
        //     } else {    
        //         return null;
        //     }
        // },
        displayStreamName() {
            const info = this.info || {};
            return getDisplayStreamName(info.stream_name_by_user, info.stream_name);
        },
        stream_name(){
            if(this.info){
                return this.info.stream_name;
            } else {    
                return null;
            }
        },
        whipUrl(){
            if(this.info){
                return this.info.whipUrl;
            } else {    
                return null;
            }
        },
        isRecording(){
            if(this.info){
                return this.info.record;
            } else {    
                return null;
            }
            // return this.switchStates ? this.switchStates.recording : false;
            // if(this.info){
            //     this.switchStates ? this.switchStates.recording : false;


            //     // return this.info.record_status;
            // } else {    
            //     return null;
            // }
        },
        EMBEDIEDURL(){
            if(this.info){
                return this.info.play_url;
            } else {    
                return null;
            }
        },
        OnpublishServer(){
            if(this.info){
                return this.info.publish_url;
            } else {    
                return null;
            }
        },
        standardVal() {
            const getStd = this.$store.getters['objectData/getStandard'];
            const privacy = getStd ? getStd('privacyData') : [];
            const categories = getStd ? getStd('youtubeCat') : [];
            return {
                privacyData: privacy.map(p => (typeof p === 'object' ? p : { label: String(p), value: p })),
                youtubeCat: categories.map(c => (typeof c === 'object' ? c : { label: String(c), value: c })),
            };
        },
        liveRelayContext() {
            const info = this.info || {};
            return info && info.uuid ? `webrtc:${info.uuid}` : null;
        },
        socialLiveInfo() {
            const info = this.info || {};
            if (!info || Object.keys(info).length === 0) {
                return null;
            }
            return {
                uuid: info.uuid,
                stream_name: info.stream_name,
                stream_name_by_user: info.stream_name_by_user,
                play_url: info.play_url,
                publish_url: info.publish_url,
                type: info.type,
                appType: info.appType,
                description: info.description || '',
                live_status: info.live_status,
            };
        }
        // ThumbnailUrl(){
        //     if(this.info){
        //         return this.info.thumb;
        //     } else {
        //         return null;
        //     }
        // }
    },
    methods: {
        ...mapActions('livestatus', ['toggleSwitch', 'saveSettings']),
        reloadPage(){
            location.reload();
        },
        async openCode() {
            const uuid = this.$route.params.uuid;
            const params = {
                uuid: uuid
            }
            const response = await WebRtcStreamApi.previewApi(params);
            // console.log("res => ", response)

            this.previewHtml = response.html;
            this.modalOpen = true;
            // console.log("res => ", this.previewHtml)
            // const blob = new Blob([this.previewHtml], { type: 'text/html' });
            // const url = URL.createObjectURL(blob);

            // const a = document.createElement('a');
            // a.href = url;
            // a.download = 'player.html';
            // a.click();
            
            // URL.revokeObjectURL(url);
        },
        async downloadCode(){
            const uuid = this.$route.params.uuid;
            const params = {
                uuid: uuid
            }
            const response = await WebRtcStreamApi.previewApi(params);
          
            this.previewHtml = response.html;
            
            const blob = new Blob([this.previewHtml], { type: 'text/html' });
            const url = URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = url;
            // a.download = 'player.html';
            a.download = 'player.php';
            a.click();

            URL.revokeObjectURL(url);
        },
        // closeModal(){
        //     this.modalOpen = false
        // },
        goLiveList(){
            this.$router.push('/webrtc/stream_create');
        },
        downloadForm(){

            const serviceJson = {
                settings: {
                    bwtest: false,
                    server: this.OnpublishServer,
                    key: this.stream_name
                },
                type: 'rtmp_custom'
            };

            const streamEncoderJson = {
                bitrate: 3000,
                keyint_sec: 0,
                preset: "superfast",
                profile: "baseline",
                tune: "zerolatency"
                // stream_encoder: {
                //     bitrate: 3000,
                //     keyint_sec: 0,
                //     preset: "superfast",
                //     profile: "baseline",
                //     tune: "zerolatency",
                // }
            };

            const basicIni = `[General]
Name=${this.stream_name}

[Video]
BaseCX=1920
BaseCY=1080
OutputCX=1280
OutputCY=720

[Panels]
CookieId=4B5DBA2A26ABE39E

[Output]
Mode=Advanced

[SimpleOutput]
StreamEncoder=x264
Preset=veryfast

[AdvOut]
TrackIndex=1
RecType=Standard
RecTracks=1
FLVTrack=1
FFOutputToFile=true
FFFormat=
FFFormatMimeType=
FFVEncoderId=0
FFVEncoder=
FFAudioMixes=1
RecSplitFileType=Time
Encoder=obs_x264
`;

            const zip = new JSZip();

            zip.file('service.json', JSON.stringify(serviceJson, null, 2));
            zip.file('streamEncoder.json', JSON.stringify(streamEncoderJson, null, 2));
            zip.file('basic.ini', basicIni);

            zip.generateAsync({ type: "blob" }).then((blob) => {
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = this.stream_name + '.zip';
                link.click();
            });
        },
        async saveChanges() {
            this.saveLoading = true;
            const frontUrl = `${window.location.protocol}//${window.location.host}`;
            const uuid = this.$route.params.uuid;
            const data = {
                ip: frontUrl,
                uuid: uuid,
                recording: this.switchStates ? this.switchStates.recording : false,
                domain: this.domain,
                privateKey: this.privateKey,
                // validTime: this.validTime
                // stream_name: this.stream_name
            };
            const success = await this.$store.dispatch('livestatus/saveSettingsWebRTC', data);
            if (success) {
                this.$emit('settingsSaved');
                this.saveLoading = false;
                this.snackbar = true;
                this.snackbarText = this.$store.getters.t('정보 수정에 성공했습니다.');
                this.snackbarError = false;

                setTimeout(() => {
                    this.snackbar = false;
                    this.snackbarText = '';
                    // this.$router.go();
                }, 2000);
            }
        },
        copyToClipboard(textToCopy) {
            if(!textToCopy){
                this.snackbar = true;
                this.snackbarText = this.$store.getters.t('복사할 텍스트가 없습니다.');
                this.snackbarError = true;
                setTimeout(() => {
                    this.snackbar = false;
                    this.snackbarError = false;
                    this.snackbarText = "";
                }, 2000);

                return;
            }

            this.$copyText(textToCopy)
                .then(() => {
                    this.snackbar = true;
                    this.snackbarText = this.$store.getters.t('텍스트가 복사되었습니다');
                    this.snackbarError = false;
                    setTimeout(() => {
                        this.snackbar = false;
                        this.snackbarText = "";
                    }, 2000);
                })
                .catch(() => {
                    alert('Failed to copy text.');
                });
        },
        async copyToClipboardHTML(textToCopy) {
            try {
                await navigator.clipboard.writeText(textToCopy);
                this.snackbar = true;
                this.snackbarText = this.$store.getters.t('텍스트가 복사되었습니다');
                this.snackbarError = false;
                setTimeout(() => {
                    this.snackbar = false;
                    this.snackbarText = "";
                }, 2000);
            } catch (err) {
                alert('Failed to copy text.');
            }
        },
        refreshIframe() {
            this.refresh();
            const originalURL = this.EMBEDIEDURL;
            this.$refs.iframe.src = '';
            this.$nextTick(() => {
                this.$refs.iframe.src = originalURL;
                const video =  this.$refs.iframe.contentWindow.document.querySelector('video');
                video.autoplay = true;
                video.play();
            });
        },
        async liveData(uuid) {
            try {
                const frontUrl = `${window.location.protocol}//${window.location.host}`;
                const data = {
                    ip: frontUrl,
                    uuid: uuid,
                };
                const response = await WebRtcStreamApi.detailApi(data);
                if(response.status == 1) this.info = response.data;

                this.live_status = this.info?.live_status ?? 0;
                this.switchStates.recording = this.info.record_status == "1";
                this.privateKey = this.info.private_key;
                // this.validTime = this.info.valid_time;
                // this.switchStates.validTime =  this.info.valid_time;
                this.domain = this.info.domain;
                this.appType = this.info.appType;

            } catch (error) {
                console.error('error', error);
            }
        },
        temp() {
            const iframe = this.$refs.iframe;
            const video = iframe.contentWindow.document.querySelector('video');
            if (!video) return;
            video.poster = "/streamon.png";
        },
        resizeVideo() {
            const iframe = this.$refs.iframe;
            const video = iframe.contentWindow.document.querySelector('video');
            const iframeDocument = iframe.contentWindow.document;
            if (!video) return;

            const container = iframe.parentElement;
            const containerWidth = container.offsetWidth;
            const videoWidth = video.videoWidth;
            const videoHeight = video.videoHeight;
            const aspectRatio = videoWidth / videoHeight;

            if (aspectRatio < 1) {
                container.style.paddingBottom = `${(videoHeight / videoWidth) * 100}%`;
            } else {
                container.style.paddingBottom = '56.25%';
            }

            video.autoplay = true;
            video.play();

        },
        refresh() {
            const uuid = this.$route.params.uuid;
            this.liveData(uuid);
        },
        toggleSwitch(switchKey) {
            if (switchKey === 'recording' && !this.isLiveRunning()) {
                this.snackbar = true;
                this.snackbarText = this.$store.getters.t('메인 라이브를 먼저 시작한 후 녹화를 켤 수 있습니다.');
                this.snackbarError = true;
                setTimeout(() => {
                    this.snackbar = false;
                    this.snackbarError = false;
                    this.snackbarText = "";
                }, 2000);
                return;
            }
            this.switchStates[switchKey] = !this.switchStates[switchKey];
            //console.log(switchKey + " 스위치가 " + (this.switchStates[switchKey] ? '켜짐' : '꺼짐') + "으로 전환됨");
        },
        isLiveRunning() {
            const status = this.live_status;
            if (status === null || status === undefined || status === '') {
                return false;
            }
            if (typeof status === 'boolean') {
                return status;
            }
            const numeric = Number(status);
            if (!Number.isNaN(numeric)) {
                return numeric === 1;
            }
            const normalized = String(status).trim().toLowerCase();
            return normalized === 'live' || normalized === 'running' || normalized === 'on';
        }
    },
    async beforeMount() {
        const uuid = this.$route.params.uuid;
        await this.liveData(uuid);
    },
    watch: {
        live_status(newStatus) {
            //console.log("newStatus", newStatus);
            if (Number(newStatus) === 1) {
                this.refreshIframe();
            }
        }
    }
}
</script>

<style>
.cont_title {
    margin-top: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #000;
    font-size: 18px;
}

.tabletitle {
    font-size: 18px;
    padding-bottom: 10px;
}

.live_left_wraper {width: 500px !important;}

@media only screen and (max-width: 600px) {
.lr_wrapper{
    display: block;
}
.right_wraper {
    margin:0px ;
}
}

.right_wraper {
    width: 100%;
    margin-left:20px ;
}

.text_box {
    word-break: break-all;
    color: #888;
    width: 100%;
}

.table_text {
    background: #fff;
}

iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.video-container video {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.video-container {
    position: relative;
    background-color: black;
    width: 100%;
    height: 500px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    border-radius: 12px;
}

.thumbnail-wrapper {
    position: relative;
    width: 300px;
    height: 200px;
}

.thumbnail-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
</style>
